import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NewJobService } from '../app-service/newJob.service';
import { SharedService } from '../app-service/shared.service';
import { newJob } from '../model/newJob';
import {ToastrService} from 'ngx-toastr'
import { StopWatchComponent } from '../stop-watch/stop-watch.component';
import { DateAdapter } from '@angular/material/core';
import { jsPDF } from 'jspdf';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-select-feature',
  templateUrl: './select-feature.component.html',
  styleUrls: ['./select-feature.component.css'],
})
export class SelectFeatureComponent implements OnInit {
  //To allow acces origin from server

  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers':
        'Origin,X-Requested-With,Content-Type,Accept,GET',
      'Access-Control-Allow-Methods': 'GET',
      'Content-Type': 'application/json',
    }),
  };

  // Dropdown for options by default selectedOption: string = "PM";
  selectedOption: string = 'PM';
  selectedSupplier: string = 'XY';
  selectedTyre: string = 'Bridgestone';
  condition: boolean = false;

  value = 'PM';
  check = false;
  showPM: boolean = true;
  showSUBLET: boolean = false;
  showTYRE: boolean = false;
  showOther: boolean = false;
  showHB: boolean = false;

  //this variable will store condition for display clock
  storeConditionForDisplayclock: boolean = true;
  //this variable store jobId which stored on NewJobService
  JobId: any;
  newJobObj: newJob;
  totalsec: number = 0;
  sec: number = 0;
  subdate = new Date();
  //person = {} as newJob;
  //New Job senario when user select tyre thenbelow var are used
  MVAInfotogetSupplierDetails: any;
  supplierList: any;
  oilsupplierList: any;
  ///we will store Mva number in this to get Tyre Supplier details
  mvaToGetTyreDropdown: any;
  timeLogDetails: any;
  showTimeArray: any;
  timeArray: any[] = [];
  timePopover = false;
  totaltimeforJob: any = '';
  MVA: number;
  disable: boolean = false;
  disableDropdown: boolean = false;
  spinner = true
  showValue: boolean = false;
  options = ['Other'];
  watchimg: string = "assets/images/stopwatch.png";
  showWC: any = localStorage.getItem("showWorkCompleted");
  showWIP: any = localStorage.getItem("showWorkInProgress");
  fromTab: string = '';
  snapshotImage: string | null = null; 
  // 🔹 Supplier dropdown variables
  supplierSearchText: string = '';
  allSuppliers: string[] = [];          // master list (fetched once)
  filteredSuppliers: string[] = [];     // filtered list for dropdown
  showAddSupplierInput = false;
  newSupplierName: string = '';

  constructor(
    private sharedService: SharedService,
    private newJobService: NewJobService,
    public dialog: MatDialog,
    private dateAdapter: DateAdapter<Date>,
    private toastr:ToastrService
  ) {
    //when select componet loads then by default all values of newJob class empty before calling to any services
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.newJobObj = {
      wwid: 0,
      employeeName: '',
      MVA: '',
      REGO: '',
      model: '',
      km: '',
      starttime: '',
      endtime: '',
      status: false,
      radiobutton: '',
      RepairOrderId: 0,
      country: '',
      state: '',
      VIN_NO:'',
      pm: {
        RepairOrderId: 0,
        exteriorlights: false,
        instrumentalsandcontrolsoperation: false,
        parkbrakeoperation: false,
        engineoil: false,
        oilfilter: false,
        underbodyforleaks: false,
        tyresforweartear: false,
        TyreDepth: false,
        NumberOfTyreUsed: '',
        TLFH: '',
        TLHR: '',
        TRHF: '',
        TRHR: '',
        TSPARE: '',
        brakepadsdepth: false,
        BLFH: '',
        BLHR: '',
        BRHF: '',
        BRHR: '',
        BSPARE: false,
        INSP_BRAKE_PADS_DEPTH:false,
        enginecompartmentforleakagewearanddamage: false,
        airfilter: false,
        fuelfliters: false,
        pollenfilter: false,
        underbonnetfluids: false,
        recordandstampservice: false,
        checkforholds: false,
        updatewizard: false,
        Comments: '',
        AIR_FILTER_REPLACED: false,
        POLLEN_FILTER_REPLACED: false,
        BRAKE_PAD_DEPTH_REPLACED: false,
        oilsupplier: '',
        supplier: '',
        tyre: '',
        VendorName: '',
        CostOfTyre: 0,
        ServiceRange:'',
        ServiceMinutes:0,
        Weight:0
      },
      tyre: {
        supplier: '',
        tyre: '',
        other: '',
        NumberOfTyre: 0,
        VendorName: '',
        CostOfTyre: 0,
      },
      sublet: {
        supplier: '',
        cost: 0,
        executePMP:false,
        ponumber:0,
        invoicenumber: 0,
        kilometres: 0,
        workcarriedout: '',
        comments: '',
        SubletDate: '',
      },
      handbackbuyback: {
        ServeBook: false,
        OWNER_MAN: false,
        PRIMARY_AND_SPARE: false,
        TOOLS_BRACE_JACK: false,
        SD_CARD: false,
        ANY_OTHER_ACCESSORIES: false,
        GLASS_FREE_DEFECTS_DRIVERS_VISION: false,
        TYRES_MATCHING_AXLE_: false,
        WHEEL_RIMs_SCRAP: false,
        WHEEL_TRIMs_SCRAP: false,
        LIGHT_REFLECTORS_STATE: false,
        CARPET_RIPPED_HEEL_PADS: false,
        INTERIOR_NO_MORE: false,
        PAINT_TO_PANEL: false,
        NZ_VEHICLE_REGISTERED: false,
        NZ_VEHICLE_CURRENT_COF: false,
        COMMENT: '',
      },
      other: {
        COMMENT: '',
      },
      timearray: [],
    } as newJob;

    //console.log('Init' + this.newJobObj);
  }

  ngOnInit(): void {
    this.getSuppliersOnce();
    console.log(this.showWC);
    console.log(this.showWIP);
    console.log(this.filteredSuppliers);
    console.log(this.newJobObj)
    this.showValue = true;
    //  binded to html file display clock according true,false of clockShow
    console.log(this.sharedService.clockShow)
    this.storeConditionForDisplayclock = this.sharedService.clockShow;
    if (this.sharedService.clockShow == false) {
      this.storeConditionForDisplayclock = false;
      this.disable = true;
      // if user is in autoPop senario then options of dropdown will be disable
      this.disableDropdown = true;
    }
    else {
      this.storeConditionForDisplayclock = true;
    }
    //console.log(this.storeConditionForDisplayclock + 'clock value');

    //assigned status if WC or WIP
    this.newJobObj.status = !this.storeConditionForDisplayclock;
    //Auto Populate Senario
    //we take jobId which stored on newJobservice and call get api method
    this.JobId = this.newJobService.jobId;
    console.log(this.JobId);
    if (this.JobId === undefined) {
      //   if(this.sharedService.wc){
      //   this.JobId=localStorage.getItem('JobId')
      //   this.storeConditionForDisplayclock=false;
      //   this.disable=true;
      //   this.disableDropdown=true
      // }
    }

    if (this.JobId != undefined && this.JobId != 0) {
      this.newJobService
        .storeJobIdOnNewService(this.JobId)
        .subscribe((JobIdDetails: any) => {
          if (JobIdDetails) {
            this.spinner = false
          }
          //console.log('AutoPopulate senario');
          console.log(JobIdDetails.Model.radiobutton)

          //if radiobutton empty scenario then we will assign mva keys to existing obj
          if (JobIdDetails.Model.radiobutton === '') {
            //console.log('disabledropwhenRadioEmpty' + this.disableDropdown);
            //this.newJobObj.radiobutton=this.value
            this.disableDropdown = false;
            this.newJobObj.RepairOrderId = JobIdDetails.Model.RepairOrderId;
            this.newJobObj.wwid = JobIdDetails.Model.wwid;
            this.newJobObj.employeeName = JobIdDetails.Model.employeeName;
            this.newJobObj.MVA = JobIdDetails.Model.MVA;
            this.newJobObj.REGO = JobIdDetails.Model.REGO;
            this.newJobObj.model = JobIdDetails.Model.model;
            this.newJobObj.km = JobIdDetails.Model.km;
            this.newJobObj.sublet.kilometres = JobIdDetails.Model.km;
            this.newJobObj.starttime = JobIdDetails.Model.starttime;
            this.newJobObj.endtime = JobIdDetails.Model.endtime;
            this.newJobObj.VIN_NO = JobIdDetails.Model.VIN_NO;
            if(this.selectedOption === "PM")
            {
              this.newJobObj.pm.ServiceRange = JobIdDetails.Model.pm.ServiceRange;
              this.newJobObj.pm.ServiceMinutes = JobIdDetails.Model.pm.ServiceMinutes;
              this.newJobObj.pm.Weight = JobIdDetails.Model.pm.Weight;
            }
            

            //var a =JobIdDetails.Model.starttime.split('T');
            // this.newJobObj.starttime=a[1].toString();
            // this.newJobObj.endtime="00:00:00";
            this.newJobObj.timearray[0] = JobIdDetails.Model.timearray[0];
            this.newJobObj.status = JobIdDetails.Model.status;
            //this.newJobObj.radiobutton=this.value

            console.log(this.newJobObj);
          } 
          else {
            console.log(this.newJobObj)
            if (this.JobId && (this.newJobObj.tyre != null || this.newJobObj.pm != null || this.newJobObj.handbackbuyback!=null)) {
              // this.selectedSupplier=this.newJobObj.tyre.supplier;
              // this.selectedTyre=this.newJobObj.tyre.tyre;
              //this.getSupplierDetailsWhenTyreisSelected(this.newJobObj.MVA,this.newJobObj.pm.supplier);
              console.log(JobIdDetails.Model)
              this.mvaToGetTyreDropdown = JobIdDetails.Model.MVA;
              this.newJobObj = JobIdDetails.Model;
              this.onSupplierSearch('');
              console.log(this.filteredSuppliers);
              console.log(this.newJobObj)
              if (this.newJobObj.sublet != null) {
                this.newJobObj.sublet.kilometres = JobIdDetails.Model.km;
                if (JobIdDetails.Model.sublet.SubletDate != '') {
                  this.subdate = new Date(JobIdDetails.Model.sublet.SubletDate);
                }
              }
              let res = this.newJobService
                .getByMVA(this.mvaToGetTyreDropdown.toString())
                .subscribe((data: any) => {
                  this.MVAInfotogetSupplierDetails = data;
                  this.supplierList = null;
                  this.supplierList = this.MVAInfotogetSupplierDetails.Model.TyreSuppliers;
                  this.oilsupplierList = this.MVAInfotogetSupplierDetails.Model.OilFilterSuppliers;
                  //this.newJobObj = JobIdDetails.Model;
                  console.log(JobIdDetails.Model.radiobutton)
                  if (JobIdDetails.Model.radiobutton === 'PM') {
                    this.applyfilter(JobIdDetails.Model.pm.supplier);
                  }
                  else if (JobIdDetails.Model.radiobutton === 'HANBACK/BUYBACK') {
                    // this.applyfilter(JobIdDetails.Model.pm.supplier);
                  }
                  else {
                    this.applyfilter(JobIdDetails.Model.tyre.supplier);
                  }

                });

              //console.log('selected Job MVA Id=' + this.mvaToGetTyreDropdown);
            }


          }

          if (JobIdDetails.Model.radiobutton != '') {
            //console.log('radio button selected');
            this.itemSelected(JobIdDetails.Model.radiobutton.toUpperCase());
          }

          //to dispaly log details

          if (!this.storeConditionForDisplayclock) {
            ///here we calculate total time for job if work completed
            // if(this.newJobObj.timearray)
            this.timeLogDetails = this.newJobObj.timearray;
            for (let i = 0, j = 0; i < this.newJobObj.timearray.length; i++) {
              if (this.newJobObj.timearray[i].endtime != '00:00:00') {
                this.timeArray[j] = this.newJobObj.timearray[i];
                j++;
              }
            }
            console.log(this.timeArray);
            this.showTimeArray = this.timeArray;
            this.timePopover = true;
            //console.log(this.timeLogDetails);
            for (let i = 0; i < this.timeLogDetails.length; i++) {
              let c = this.timeLogDetails[i].clocktime.toString().split(':');
              this.sec = +c[0] * 60 * 60 + +c[1] * 60 + +c[2];
              this.totalsec = this.totalsec + this.sec;
            }
            //console.log(this.totalsec);
            let hours = String(Math.floor(this.totalsec / 3600)).padStart(
              2,
              '0'
            );
            this.totalsec %= 3600;
            let minutes = String(Math.floor(this.totalsec / 60)).padStart(
              2,
              '0'
            );
            let seconds = String(this.totalsec % 60).padStart(2, '0');
            // minutes = String(minutes).padStart(2, "0");
            // hours = String(hours).padStart(2, "0");
            // seconds = String(seconds).padStart(2, "0");
            //console.log(hours + ':' + minutes + ':' + seconds);
            this.totaltimeforJob = hours + ':' + minutes + ':' + seconds;
          }
          console.log(this.newJobObj.starttime)
          this.sharedService.saveStartTime(this.newJobObj.starttime);
          console.log(this.newJobObj);
          //if user is in autoPop senario then options of dropdown will be disable
          if (this.newJobObj.radiobutton != '') {
            this.disableDropdown = true;
          }
          // console.log("Supplier value:", this.newJobObj.sublet.supplier);
          // console.log("Dropdown list:", this.filteredSuppliers);
        });
    }
    else {
      //newJob scenario
      this.spinner = false
      //console.log('new Entry');
      // below we get  NewScanner Obj which is shared on SharedService
      this.value = this.sharedService.selectedoption;
      this.selectedOption = this.value;
      this.itemSelected(this.value);
      //console.log(this.sharedService.sharedfromNewEntrynewjobObj1);

      // this.newJobObj=JSON.parse(JSON.stringify(this.sharedService.sharedfromNewEntrynewjobObj1));

      this.newJobObj.radiobutton = this.value;
      this.newJobObj.RepairOrderId =
        this.sharedService.sharedfromNewEntrynewjobObj1.RepairOrderId;
      this.newJobObj.MVA = this.sharedService.sharedfromNewEntrynewjobObj1.MVA;
      this.newJobObj.REGO =
        this.sharedService.sharedfromNewEntrynewjobObj1.REGO;
      this.newJobObj.model =
        this.sharedService.sharedfromNewEntrynewjobObj1.model;
      this.newJobObj.VIN_NO =
        this.sharedService.sharedfromNewEntrynewjobObj1.VIN_NO;
      this.newJobObj.pm.ServiceRange =
        this.sharedService.sharedfromNewEntrynewjobObj1.pm.ServiceRange;
      this.newJobObj.km =
        this.sharedService.sharedfromNewEntrynewjobObj1.km.toString();
      this.newJobObj.employeeName =
        this.sharedService.sharedfromNewEntrynewjobObj1.employeeName;
      this.newJobObj.starttime =
        this.sharedService.sharedfromNewEntrynewjobObj1.starttime;
      this.newJobObj.wwid =
        this.sharedService.sharedfromNewEntrynewjobObj1.wwid;
      this.newJobObj.timearray =
        this.sharedService.sharedfromNewEntrynewjobObj1.timearray;
      if (this.newJobObj.sublet != null) {
        if (this.newJobObj.sublet.SubletDate == '') {
          this.subdate = new Date();
        }
      }


      console.log(this.newJobObj);
      //console.log(this.newJobObj.radiobutton);
      // In newJob senario when tyre is selected but instead of calling mvaDetails service i have shared details from newEntry Scanner componnet to shared service
      //this.getSupplierDetailsWhenTyreisSelected(this.sharedService.sharedfromNewEntrynewjobObj1.MVA);
      if (this.sharedService.sharedfromNewEntrynewjobObj1.MVA != '') {
        this.supplierList = this.sharedService.mvaData.TyreSuppliers;
        this.oilsupplierList = this.sharedService.mvaData.OilFilterSuppliers;
      }
    }
    
  }
  commentPattern = /^[A-Za-z ]+$/; // Allows only letters and spaces
  commentValid: boolean = false;   // To track comment validation
  
  validateComment(): void {
    if (this.newJobObj.radiobutton === 'OTHER' || this.newJobObj.MVA === '') {
      const comment = this.newJobObj?.other?.COMMENT?.trim();
      this.commentValid = this.commentPattern.test(comment) && comment.length > 0;
    } else {
      this.commentValid = true; // No validation required for the first div
    }
  }
  
  isCommentValid(): boolean {
    return this.commentValid;
  }
  compareSupplier(a: any, b: any): boolean {
    return a === b;
  }
  tyreList: any
  applyfilter(filtervalue: string) {
    this.supplierList.forEach((ele: any) => {
      if (ele.SupplierName == filtervalue) {
        this.tyreList = ele.ProductInfo;
      }
    });

  }

  getSupplierDetailsWhenTyreisSelected(mva: any, pselectedSupplier: any) {
    this.mvaToGetTyreDropdown = mva;
    let res = this.newJobService
      .getByMVA(this.mvaToGetTyreDropdown.toString())
      .subscribe((data: any) => {
        this.MVAInfotogetSupplierDetails = data;
        this.supplierList = null;
        this.supplierList = this.MVAInfotogetSupplierDetails.Model.TyreSuppliers;
        this.oilsupplierList = this.MVAInfotogetSupplierDetails.Model.OilFilterSuppliers;
        this.applyfilter(pselectedSupplier);
      });
  }

  // selectedSupplier(name: any) {
  //   //console.log(name);
  //   //console.log(this.Model.Suppliers)
  // }
  // selectedTyre(name: any) {
  //   console.log(name);
  // }

  itemSelected(newValue: any) {
    console.log((this.value = newValue));
    this.selectedOption = this.value;
    this.newJobObj.radiobutton = this.value;
    // To freez the dropdown after user select any option

    this.disableDropdown = true;

    if (this.value == 'PM') {
      this.showPM = true;
      this.showSUBLET = false;
      this.showOther = false;
      this.showTYRE = false;
      this.showHB = false;
      //console.log(this.showPM);
      // this.condition=true
    } else if (this.value == 'TYRE') {
      this.showTYRE = true;
      this.showPM = false;
      this.showSUBLET = false;
      this.showOther = false;
      this.showHB = false;
      //console.log(this.showTYRE);
    } else if (this.value == 'SUBLET') {
      this.showTYRE = false;
      this.showPM = false;
      this.showSUBLET = true;
      this.showOther = false;
      this.showHB = false;
      //console.log(this.showSUBLET);
    }
    else if (this.value == 'HANBACK/BUYBACK') {
      this.showTYRE = false;
      this.showPM = false;
      this.showSUBLET = false;
      this.showOther = false;
      this.showHB = true;
      // console.log(this.showHB);
    } else {
      this.showTYRE = false;
      this.showPM = false;
      this.showSUBLET = false;
      this.showOther = true;
      this.showHB = false;
      // console.log(this.showOther);
    }
  }

  otherVal: any;
  EnteredValue() {
    //console.log(this.otherVal);
  }

  //when we click on  clock  button below method call which shared on newJobService
  postData() {
    if (this.newJobObj.radiobutton === '') {
      this.newJobObj.radiobutton = 'PM';
    }
    console.log(this.newJobObj);
    this.sharedService.postDataObjStoredOnSharedService(this.newJobObj);
    this.sharedService.setsubdate(this.subdate);
    this.onJobStatus();
  }
  saveComments() {
    
    this.newJobService.saveCommentData(this.newJobObj)
    .subscribe((data:any)=>{
      //console.log(data.Success)
            if(data.Success)
            {
                this.toastr.success('Comments Saved Successfully', '', {
                  timeOut:3000,
                  positionClass: 'toast-bottom-full-width'
                  })
                
            }
            else
            {
                  this.toastr.warning('Comments not Saved', '', {
                    timeOut:3000,
                    positionClass: 'toast-bottom-full-width'
                    })
            }
    });
  }
  onJobStatus() {
    //this.sharedService.onClickJobStatus();
    const dialogRef = this.dialog.open(StopWatchComponent, {
      panelClass: 'app-dialog',
    });
  }
  goBack() {
  // Route back with tab info
  }
  downloadPDF() {
    const doc = new jsPDF();
    let y = 10;

    //Add Logo
    const img = new Image();
    img.src = 'assets/images/Abglogo.jpg';
    const imgCheck = new Image();
    const imgUnCheck = new Image();
    imgCheck.src = 'assets/images/CheckedBox.png';
    imgUnCheck.src = 'assets/images/UncheckedBox.png';

    img.onload = () => {
      imgCheck.onload = () => {
        imgUnCheck.onload = () => {
          doc.addImage(img, 'PNG', 10, 5, 60, 15); 
          y = 20;
          // Title
          doc.setFontSize(13);    
          doc.text(`Workshop Job Detail Report`, 75, y);
          y += 10;

          // Dropdown
          doc.setFontSize(7);
          doc.text(`Category`, 10, y);
          y += 5;
          doc.setFontSize(11);
          doc.text(`${this.selectedOption || '-'}`, 10, y);
          y += 2;
          doc.text(`..................................................................................................................................................................................`, 10, y);
          y += 6;

          // Headers
          doc.setFontSize(11); // Smaller font to fit everything on one line
          const headerLine = [
            `JOB ID: ${this.newJobObj?.RepairOrderId || '-'}`,
            `VIN: ${this.newJobObj?.VIN_NO || '-'}`,
            `REGO: ${this.newJobObj?.REGO || '-'}`,
            `MVA: ${this.newJobObj?.MVA || '-'}`,
            `Model Description: ${this.newJobObj?.model || '-'}`,
            `KMS: ${this.newJobObj?.km || '-'}`,
            `END DATE: ${this.newJobObj?.endtime?.substring(0, 10) || '-'}`
          ].join('    '); // 4 spaces between fields
        
          // Truncate or wrap if text exceeds page width
          const maxWidth = 190;
          const headerTextWidth = doc.getTextWidth(headerLine);
          if (headerTextWidth <= maxWidth) {
            doc.text(headerLine, 10, y);
            y += 10;
          } else {
            doc.setFontSize(7); // Reduce font further if overflow
            doc.text(headerLine, 10, y);
            y += 10;
          }
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(10);
          //y += 8;
        
          if(this.selectedOption == "PM")
          {
            const checklistPM = [
              { label: 'Check exterior lights', value: this.newJobObj?.pm?.exteriorlights },
              { label: 'Check instrumentals and control operation', value: this.newJobObj?.pm?.instrumentalsandcontrolsoperation },
              { label: 'Inspect park brake operation and adjust if required', value: this.newJobObj?.pm?.parkbrakeoperation },
              { label: 'Change engine oil', value: this.newJobObj?.pm?.engineoil },
              { label: 'Change oil filter', value: this.newJobObj?.pm?.oilfilter }, 
              { label: 'Oil Supplier', value: this.newJobObj?.pm?.oilsupplier }, // if change oil filter true 
              { label: 'Inspect underbody for leaks, wear and tear and damage', value: this.newJobObj?.pm?.underbodyforleaks },
              { label: 'Inspect tyres for wear/tear. Rotate where required', value: this.newJobObj?.pm?.tyresforweartear },
              { label: 'Inspect engine compartment for leakage, wear and damage', value: this.newJobObj?.pm?.enginecompartmentforleakagewearanddamage },
              { label: 'Record tyre depth', value: this.newJobObj?.pm?.TyreDepth },
              { label: 'Number of tyres used', value: this.newJobObj?.pm?.NumberOfTyreUsed },
              { label: 'LHF', value: this.newJobObj?.pm?.TLFH },
              { label: 'LHR', value: this.newJobObj?.pm?.TLHR }, 
              { label: 'RHF', value: this.newJobObj?.pm?.TRHF },
              { label: 'RHR', value: this.newJobObj?.pm?.TRHR },
              { label: 'SPARE', value: this.newJobObj?.pm?.TSPARE },
              { label: 'Select Supplier', value: this.newJobObj?.pm?.supplier },
              { label: 'Select Tyre', value: this.newJobObj?.pm?.tyre },
              { label: 'Vendor Name', value: this.newJobObj?.pm?.VendorName }, //If Select Supplier  == other
              { label: 'Cost Of Tyre', value: this.newJobObj?.pm?.CostOfTyre }, //If Select Supplier  == other
              { label: 'Check air filter', value: this.newJobObj?.pm?.airfilter },
              { label: 'Replaced', value: this.newJobObj?.pm?.AIR_FILTER_REPLACED },
              { label: 'Inspect brake pads depth', value: this.newJobObj?.pm?.INSP_BRAKE_PADS_DEPTH },
              { label: 'Record brake pad depth', value: this.newJobObj?.pm?.brakepadsdepth },
              { label: 'Replaced', value: this.newJobObj?.pm?.BRAKE_PAD_DEPTH_REPLACED },
              { label: 'LHF', value: this.newJobObj?.pm?.BLFH },  
              { label: 'LHR', value: this.newJobObj?.pm?.BLHR },  
              { label: 'RHF', value: this.newJobObj?.pm?.BRHF },  
              { label: 'RHR', value: this.newJobObj?.pm?.BRHR },  
              { label: 'Replace fuel filter as required', value: this.newJobObj?.pm?.fuelfliters },
              { label: 'Check pollen filter/clean or replace as required', value: this.newJobObj?.pm?.pollenfilter },
              { label: 'Replaced', value: this.newJobObj?.pm?.POLLEN_FILTER_REPLACED },
              { label: 'Inspect and top up all under bonnet fluids', value: this.newJobObj?.pm?.underbonnetfluids },
              { label: 'Record and stamp service book', value: this.newJobObj?.pm?.recordandstampservice },
              { label: 'Check for any holds against the car, and remove if required', value: this.newJobObj?.pm?.checkforholds },
              { label: 'Update Wizard', value: this.newJobObj?.pm?.updatewizard },
              { label: 'Comments', value: this.newJobObj?.pm?.Comments },
            ];
            let x = 0;
            checklistPM.forEach(item => {
              //Skip "Oil Supplier" if oil filter is not selected
              if ((item.label === 'Oil Supplier' && !this.newJobObj?.pm?.oilfilter) || ((item.label === 'Vendor Name' || item.label === 'Cost Of Tyre') && this.newJobObj?.pm?.supplier != 'Other')) 
              {
                return; // Skip this item
              }

              // Add checkbox image
              if(  item.label != 'Oil Supplier' && item.label != 'Number of tyres used' && item.label != 'LHF' && item.label != 'LHR' && item.label != 'RHF' 
                && item.label != 'RHR' && item.label != 'SPARE' && item.label != 'Select Supplier' && item.label != 'Select Tyre' && item.label != 'Vendor Name'
                && item.label != 'Cost Of Tyre' && item.label != 'Replaced' && item.label != 'Comments')
              {

                if(item.label === 'Check air filter') {
                  x = 50;
                }
                else if(item.label === 'Record brake pad depth'){
                  x = 65;
                }
                else if(item.label === 'Check pollen filter/clean or replace as required'){
                  x = 100;
                }
              
                if (item.value) {
                  doc.addImage(imgCheck, 'PNG', 10, y, 4, 4);
                } else {
                  doc.addImage(imgUnCheck, 'PNG', 10, y, 4, 4);
                }
              
                // Add label text to the right of the image
                doc.text(item.label, 16, y + 3); // Shift right and slightly down for alignment
                y += 7;
              }
              else if (item.label === 'Oil Supplier') {
                // Add label text 
                doc.text(item.label, 50, y - 4); 
                doc.text(item.value.toString(), 70, y - 4);

              }
              else if (item.label === 'Number of tyres used') {
                // Add label text 
                doc.text(item.label, 10, y+3); 
                doc.text(item.value.toString(), 50, y+3);
                y += 7;
              }
              else if (item.label === 'LHF') {
                // Add label text 
                doc.text(item.label, 10, y+3); 
                doc.text(item.value.toString(), 20, y+3);

              }
              else if (item.label === 'LHR') {
                // Add label text 
                doc.text(item.label, 40, y+3); 
                doc.text(item.value.toString(), 50, y+3);

              }
              else if (item.label === 'RHF') {
                // Add label text 
                doc.text(item.label, 70, y+3); 
                doc.text(item.value.toString(), 80, y+3);

              }
              else if (item.label === 'RHR') {
                // Add label text 
                doc.text(item.label, 100, y+3); 
                doc.text(item.value.toString(), 110, y+3);
                y += 7;
              }
              else if (item.label === 'SPARE') {
                // Add label text 
                doc.text(item.label, 130, y-4); 
                doc.text(item.value.toString(), 150, y-4);

              }
              else if (item.label === 'Select Supplier') {
                // Add label text 
                y += 3;
                doc.text(item.label, 10, y); 
                doc.text(item.value.toString(), 40, y);
                y += 7;
              }
              else if (item.label === 'Select Tyre') {
                // Add label text 
                doc.text(item.label, 10, y); 
                doc.text(item.value.toString(), 40, y);
                y += 4;
              }
              else if (item.label === 'Vendor Name') {
                // Add label text 
                doc.text(item.label, 10, y+3); 
                doc.text(item.value.toString(), 40, y+3);
                y += 10;
              }
              else if (item.label === 'Cost Of Tyre') {
                // Add label text 
                doc.text(item.label, 10, y); 
                doc.text(item.value.toString(), 40, y);
                y += 4;
              }
              else if (item.label === 'Replaced') {
                if (item.value) {
                  doc.addImage(imgCheck, 'PNG', x, y-7, 4, 4);
                } else {
                  doc.addImage(imgUnCheck, 'PNG', x, y-7, 4, 4);
                }
                // Add label text 
                doc.text(item.label, x+6, y-4); 

              }
              else if (item.label === 'Comments') {
                // Add label text
                y += 3; 
                doc.text(item.label, 10, y); 
                //doc.text(item.value.toString(), 50, y);
                const comment = item.value?.toString() || '-';
                const boxX = 10;      // Same as label
                const boxY = y + 4;   // As you requested
                const boxWidth = 100;

                // Split the text into lines to fit inside 70 width
                const lines = doc.splitTextToSize(comment, boxWidth);
                const lineHeight = 5; // Space between lines
                const boxHeight = lines.length * lineHeight;

                // Draw the box
                doc.rect(boxX, boxY, boxWidth, boxHeight);

                // Add the text inside the box
                doc.text(lines, boxX + 2, boxY + 4); // Small left padding, start inside the box

                // Update y after box
                y = boxY + boxHeight + 3;
              }
            
            
              // Add page if near end
              if (y > 270) {
                doc.addPage();
                y = 10;
              }
            });
          }
          else if (this.selectedOption == "HANBACK/BUYBACK")
          {
            const checklistHB = [
              { label: 'Service Book', value: this.newJobObj?.handbackbuyback?.ServeBook },
              { label: 'Owners Manual', value: this.newJobObj?.handbackbuyback?.OWNER_MAN },
              { label: 'Primary and Spare Key', value: this.newJobObj?.handbackbuyback?.PRIMARY_AND_SPARE },
              { label: 'Tools being wheel brace and jack', value: this.newJobObj?.handbackbuyback?.TOOLS_BRACE_JACK },
              { label: 'SD card', value: this.newJobObj?.handbackbuyback?.SD_CARD }, 
              { label: 'Any other accessories i.e. air compressor', value: this.newJobObj?.handbackbuyback?.ANY_OTHER_ACCESSORIES }, // if change oil filter true 
              { label: 'Glass, free of defects that could impair the drivers vision', value: this.newJobObj?.handbackbuyback?.GLASS_FREE_DEFECTS_DRIVERS_VISION },
              { label: 'Tyres matching on axels and comply with Roadworthy standards', value: this.newJobObj?.handbackbuyback?.TYRES_MATCHING_AXLE_ },
              { label: 'Wheel Rims, with no more than 15% of scrapes and scratches', value: this.newJobObj?.handbackbuyback?.WHEEL_RIMs_SCRAP },
              { label: 'Wheel Trims, with no more than 15% of scrapes and scratches', value: this.newJobObj?.handbackbuyback?.WHEEL_TRIMs_SCRAP },
              { label: 'Lights/Reflectors & Garnish, comply with Roadworthy standards for each state', value: this.newJobObj?.handbackbuyback?.LIGHT_REFLECTORS_STATE },
              { label: 'Carpets / Upholstery, Look for tears, rips, cuts, holes, burn holes, stained, mismatched colours, and holes or ripped heel pads', value: this.newJobObj?.handbackbuyback?.CARPET_RIPPED_HEEL_PADS },
              { label: 'Interior, no more than 3 permanent less than 15mm in diameter', value: this.newJobObj?.handbackbuyback?.INTERIOR_NO_MORE }, 
              { label: 'Paint to Panel per standard Fair Wear and Tear Guidelines', value: this.newJobObj?.handbackbuyback?.PAINT_TO_PANEL },
              { label: 'NZ: Vehicle Registered', value: this.newJobObj?.handbackbuyback?.NZ_VEHICLE_REGISTERED },
              { label: 'SPNZ: Vehicle has current COF', value: this.newJobObj?.handbackbuyback?.NZ_VEHICLE_CURRENT_COF },
              { label: 'Comments', value: this.newJobObj?.handbackbuyback?.COMMENT },
            ];
            let x = 0;
            checklistHB.forEach(item => {
              if (item.label != 'Comments') {
                if (item.value) {
                  doc.addImage(imgCheck, 'PNG', 10, y, 4, 4);
                } else {
                  doc.addImage(imgUnCheck, 'PNG', 10, y, 4, 4);
                }
              
                // Add label text to the right of the image
                doc.text(item.label, 16, y + 3); // Shift right and slightly down for alignment
                y += 7;
              }
              else if (item.label === 'Comments') {
                // Add label text
                y += 3; 
                doc.text(item.label, 10, y); 
                //doc.text(item.value.toString(), 50, y);
                const comment = item.value?.toString() || '-';
                const boxX = 10;      // Same as label
                const boxY = y + 4;   // As you requested
                const boxWidth = 100;
                // Split the text into lines to fit inside 70 width
                const lines = doc.splitTextToSize(comment, boxWidth);
                const lineHeight = 5; // Space between lines
                const boxHeight = lines.length * lineHeight;
                // Draw the box
                doc.rect(boxX, boxY, boxWidth, boxHeight);
                // Add the text inside the box
                doc.text(lines, boxX + 2, boxY + 4); // Small left padding, start inside the box
                // Update y after box
                y = boxY + boxHeight + 3;
              }
            
            
              // Add page if near end
              if (y > 270) {
                doc.addPage();
                y = 10;
              }
            });
          }
          else if (this.selectedOption == "SUBLET")
          {
            const checklistSub = [
              { label: 'Supplier', value: this.newJobObj?.sublet?.supplier },
              { label: 'Cost ex gst', value: this.newJobObj?.sublet?.cost },
              { label: 'call Execute PMP (Preventattive Maintanance) in Fleet System', value: this.newJobObj?.sublet?.executePMP },
              { label: 'PO Number', value: this.newJobObj?.sublet?.ponumber },
              { label: 'Invoice Number', value: this.newJobObj?.sublet?.invoicenumber },
              { label: 'Kilometres', value: this.newJobObj?.sublet?.kilometres },
              { label: 'Work Carried Out', value: this.newJobObj?.sublet?.workcarriedout },
              { label: 'Sublet Date', value: this.formatDate(this.subdate)  },
              { label: 'Comments', value: this.newJobObj?.sublet?.comments },
            ];
            let x = 0;
            checklistSub.forEach(item => {
              if (item.label != 'Comments') {
                if(item.label === 'call Execute PMP (Preventattive Maintanance) in Fleet System')
                {
                  if (item.value) {
                  doc.addImage(imgCheck, 'PNG', 10, y-3, 4, 4);
                  } else {
                  doc.addImage(imgUnCheck, 'PNG', 10, y-3, 4, 4);
                  }
                  doc.text(item.label, 16, y  ); 
                  y += 7;
                }
                else
                {
                  // Add label text 
                  doc.text(item.label, 10, y ); 
                  doc.text(item.value.toString(), 50, y );
                  y += 7;
                }
                
              }
              else if (item.label === 'Comments') {
                // Add label text
                //y += 3; 
                doc.text(item.label, 10, y); 
                //doc.text(item.value.toString(), 50, y);
                const comment = item.value?.toString() || '-';
                const boxX = 10;      // Same as label
                const boxY = y + 4;   // As you requested
                const boxWidth = 100;
                // Split the text into lines to fit inside 70 width
                const lines = doc.splitTextToSize(comment, boxWidth);
                const lineHeight = 5; // Space between lines
                const boxHeight = lines.length * lineHeight;
                // Draw the box
                doc.rect(boxX, boxY, boxWidth, boxHeight);
                // Add the text inside the box
                doc.text(lines, boxX + 2, boxY + 4); // Small left padding, start inside the box
                // Update y after box
                y = boxY + boxHeight + 3;
              }
            
            
              // Add page if near end
              if (y > 270) {
                doc.addPage();
                y = 10;
              }
            });
          }
          else if (this.selectedOption == "TYRE")
          {
            const checklistTyre = [
              { label: 'Select Supplier', value: this.newJobObj?.tyre?.supplier },
              { label: 'Select Tyre', value: this.newJobObj?.tyre?.tyre },
              { label: 'Vendor Name', value: this.newJobObj?.tyre?.VendorName },
              { label: 'Cost Of Tyre', value: this.newJobObj?.tyre?.CostOfTyre },
              { label: 'Number Of Tyres Used', value: this.newJobObj?.tyre?.NumberOfTyre },
              { label: 'Comments', value: this.newJobObj?.tyre?.other },
            ];
            let x = 0;
            checklistTyre.forEach(item => {
              if (item.label != 'Comments') {
                // Add label text 
                if (item.label != 'Vendor Name' && item.label != 'Cost Of Tyre')
                {
                  doc.text(item.label, 10, y ); 
                  doc.text(item.value.toString(), 50, y );
                  y += 7;
                }
                else if (this.newJobObj?.tyre?.supplier === "Other")
                {
                  doc.text(item.label, 10, y ); 
                  doc.text(item.value.toString(), 50, y );
                  y += 7;
                } 
                
              }
              else if (item.label === 'Comments') {
                // Add label text
                //y += 3; 
                doc.text(item.label, 10, y); 
                //doc.text(item.value.toString(), 50, y);
                const comment = item.value?.toString() || '-';
                const boxX = 10;      // Same as label
                const boxY = y + 4;   // As you requested
                const boxWidth = 100;
                // Split the text into lines to fit inside 70 width
                const lines = doc.splitTextToSize(comment, boxWidth);
                const lineHeight = 5; // Space between lines
                const boxHeight = lines.length * lineHeight;
                // Draw the box
                doc.rect(boxX, boxY, boxWidth, boxHeight);
                // Add the text inside the box
                doc.text(lines, boxX + 2, boxY + 4); // Small left padding, start inside the box
                // Update y after box
                y = boxY + boxHeight + 3;
              }
            
            
              // Add page if near end
              if (y > 270) {
                doc.addPage();
                y = 10;
              }
            });
          }
          else 
          {
            const checklistOther = [
              { label: 'COMMENT', value: this.newJobObj?.other?.COMMENT },
            ];
            let x = 0;
            checklistOther.forEach(item => {
              // Add label text
              //y += 3; 
              doc.text(item.label, 10, y); 
              //doc.text(item.value.toString(), 50, y);
              const comment = item.value?.toString() || '-';
              const boxX = 10;      // Same as label
              const boxY = y + 4;   // As you requested
              const boxWidth = 100;
              // Split the text into lines to fit inside 70 width
              const lines = doc.splitTextToSize(comment, boxWidth);
              const lineHeight = 5; // Space between lines
              const boxHeight = lines.length * lineHeight;
              // Draw the box
              doc.rect(boxX, boxY, boxWidth, boxHeight);
              // Add the text inside the box
              doc.text(lines, boxX + 2, boxY + 4); // Small left padding, start inside the box
              // Update y after box
              y = boxY + boxHeight + 3;
              
              // Add page if near end
              if (y > 270) {
                doc.addPage();
                y = 10;
              }
            });
          }

          doc.setFontSize(12);    
          doc.text(`Legend: `, 10, 250);
          doc.addImage(imgCheck, 'PNG', 28, 246, 5, 5);
          doc.text(` action has been carried out`, 33, 250);
          doc.setFont('helvetica', 'italic');
          // doc.text(`Disclaimer: The information contained in this document is proprietary of W.T.H. Pty Ltd. It shall`, 10, 272);
          // doc.text(`not be used, reproduced, or disclosed to others without the express and written consent of W.T.H. Pty Ltd.`, 10, 279);
          doc.text(`Disclaimer: The information provided is intended to be accurate and up to date at the time the`, 10, 257);
          doc.text(`information is provided. However, it is provided for general information purposes only and should not `, 10, 264);
          doc.text(`be relied upon as the sole basis for making decisions. We make no representations or warranties of `, 10, 271);
          doc.text(`any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability `, 10, 278);
          doc.text(`of the information. Any reliance you place on such information is strictly at your own risk. `, 10, 285);
          

          
          // Save the PDF
          doc.save('JobDetails.pdf');
        };
      };
    };
  }
  formatDate(date: Date | string): string {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString('en-GB'); // 'en-GB' gives dd/mm/yyyy
  }
  getSuppliersOnce(): void {
    this.newJobService.GetSubletSupplierList('ALL')
      .subscribe({
        next: (response: any) => {
          // ✅ Extract data from response.Model
          if (response && response.Model) {
            this.allSuppliers = response.Model.map((x: any) => x.SupplierName);
            this.filteredSuppliers = [...this.allSuppliers];
          } else {
            this.allSuppliers = [];
            this.filteredSuppliers = [];
          }
        },
        error: (err: any) => console.error('Error fetching suppliers:', err)
      });
  }

  // 🔹 Local filter when typing in the search field
  onSupplierSearch(searchText: string): void {

    if (!searchText) {
      this.filteredSuppliers = [...this.allSuppliers];
    } else {
      // Case-insensitive filtering
      const lowerText = searchText.toLowerCase();
      this.filteredSuppliers = this.allSuppliers.filter((supplier:any) =>
        supplier.toLowerCase().includes(lowerText)
      );
    }

    // ✅ Always append "+ Add Supplier" as last item
    if (!this.filteredSuppliers.includes('+ Add Supplier')) {
      this.filteredSuppliers.push('+ Add Supplier');
    }
  }

  // 🔹 When supplier selected
  onSupplierSelected(selectedValue: string): void {
    if (selectedValue === '+ Add Supplier') {
      this.showAddSupplierInput = true;
      return;
    }

    this.newJobObj.sublet.supplier = selectedValue;
    this.supplierSearchText = '';
    this.showAddSupplierInput = false;
  }
  // 🔹 Handle dropdown open/close
  onSupplierDropdown(opened: boolean): void {
    if (opened) {
      // when dropdown opens, refresh list
      this.onSupplierSearch('');
    } else {
      // when dropdown closes, clear search
      this.supplierSearchText = '';
    }
  }

  // 🔹 Cancel adding supplier
  cancelAddSupplier(event: Event): void {
    event.stopPropagation();
    this.showAddSupplierInput = false;
    this.newSupplierName = '';
  }

  // 🔹 Confirm adding supplier
  confirmAddSupplier(event: Event): void {
    event.stopPropagation();
    const name = this.newSupplierName.trim();
    if (!name) return;

    this.newJobService.insertSubletSupplier('AU', name).subscribe({
      next: (response: any) => {
        if (response?.Message !== "Supplier Already Exists") {
          this.allSuppliers.push(name);
          this.newJobObj.sublet.supplier = name;
          this.showAddSupplierInput = false;
          this.newSupplierName = '';
          this.onSupplierSearch(''); // refresh dropdown
        } else {
          // Optional: show a message to user
          this.toastr.warning('Supplier Already Exists', '', {
            timeOut:3000,
            positionClass: 'toast-bottom-full-width'
          })
        }
      },
      error: (err) => console.error('Error adding supplier:', err)
    });
  }
}
